/*
 * Created on Mon Jun 28 2021
 *
 * Copyright (c) 2021 Khor Chai Hong
 */

import React, { useState, useEffect, useRef, useReducer, forwardRef, useImperativeHandle } from 'react';
import { Link, useHistory } from "react-router-dom";
import { images, mobileImages } from '../constants';
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import preloader from "../assets/images/preloaders/11-preloader-8px-ec0f69.gif";
import preloader2 from "../assets/images/preloaders/04-preloader-4px-f5f5f5.gif";
import { Navigation } from "../Header";
import TopNav from 'components/shared/top-nav'
import { Footer } from "../Footer";
import { ErrorPopup, Input, PasswordInput, FormButtons, addEmptyFields, clearEmptyFields, CloseButton } from '../components';
import { useWindowDimensions } from '../utils/helpers';
import { MdKeyboardArrowRight } from "react-icons/md";
import Modal from 'react-bootstrap/Modal';
import { fakeFacename } from '../temp_database';
import { authorize } from '../apis/login.api';
import{ updateAuthorizationHeader } from '../apis/api';
import useNotifyAlert from '../hooks/notify-alert.hook';
import useAuth from '../hooks/auth.hook'
import { useQueryClient } from '@tanstack/react-query';

import useTriggerPasswordReset from '../hooks/trigger-password-reset.hook';

import {
  checkEmailExist
} from "../apis/user.api";

const randomImages = Object.values(images).filter((img) => img.includes('login-bg'));
const randomMobileImages = Object.values(mobileImages).filter((img) => img.includes('login-bg'));
const randomNumber = Math.floor(Math.random() * randomImages.length);
const randomMobileNumber = Math.floor(Math.random() * randomMobileImages.length);
const randomInt = Math.floor(Math.random() * 2);


yup.addMethod(yup.string, "registeredEmail", function (args) {
  const message = args
  return this.test('email', message, function(value) {
      const { path, createError } = this;
      return new Promise((resolve, reject) => {
          checkEmailExist(value).then(res => {
              if (res.data.result)
                resolve(true)
              else
                  reject(createError({ path, message }))

          })
      })
  })
});

/*
yup.addMethod(yup.string, "registeredPassword", function (errorMessage) {
  return this.test('password', errorMessage, function (value) {
    return (
      value && fakePasswords.includes(value)
    );
  });
});
*/
const schema = yup.object().shape({
  email: yup
    .string()
    .required()
    .email(),
  password: yup
    .string()
    .required(),
});

const schema2 = yup.object().shape({
  email2: yup
    .string()
    .required()
    .email('Oops! Invalid email address. Please try again.')
    .registeredEmail('Oops! This email address is not registered. <br/>Please try again or <a href="/signup">sign up</a> instead?')
});


export default function Login() {
  document.body.style.background = '#AA0048';

  const { setNotifyAlert } = useNotifyAlert()
  const queryClient = useQueryClient()
  const { setSession } = useAuth()

  const methods = useForm({
    shouldFocusError: false,
    resolver: yupResolver(schema),
  });
  const { 
    handleSubmit, 
    formState: { 
      errors, 
      isSubmitted, 
      isSubmitting 
    }, 
    setError } = methods;

  const closeButtonRef = useRef();
  const history = useHistory();

  const [formData, setFormData] = useState([]);
  const [forgottenEmail, setForgottenEmail] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const { windowWidth, isMobile } = useWindowDimensions();

  const onSubmit = async (data, e) => {
    setFormData(data);
    
    queryClient.clear();
    queryClient.removeQueries();

    try {
      const result = await authorize({
        username: data.email,
        password: data.password
      })

      const { accessToken, reactivated, profile } = result

      updateAuthorizationHeader(accessToken.token)

      setSession({
        profile, 
        accessToken
      })
      
      localStorage.setItem(`${process.env.REACT_APP_HOST}:user`, JSON.stringify(accessToken));
      if (reactivated) {
        setNotifyAlert({
          title: `Wow, glad to have you back ${profile.name}!`,
          body: `Your account has now been reactivated!<br/>
                We and the fashion community have missed you! :)`
        })
      }
      if (profile.homepage === 1) {
        history.push('/home');
      } else
      if (profile.homepage === 2) {
        history.push('/zine');
      } else
      if (profile.homepage === 3) {
        history.push('/my-profile');
      } else {
        history.push('/home');
      }

    } catch(err) {
      console.log(err)
      
      setError('password', 'validate');
    }
  }
  
  const getForgottenEmail = (forgottenEmail) => {
    setForgottenEmail(forgottenEmail);
    setShowModal(true)
  }

  useEffect(() => {
    if (isSubmitted || isSubmitting) addEmptyFields(errors);
    // eslint-disable-next-line
  }, [isSubmitted, isSubmitting]);

  return (
    <div className="page">
      <ForgotPasswordModal 
        ref={closeButtonRef} 
        passForgottenEmail={getForgottenEmail} 
        windowWidth={windowWidth} 
        onSuccess={() => {
          setShowModal(true)
        }}
        onError={() => {
          setShowErrorModal(true)
        }}
      />
      {showModal ? <ConfirmationModal email={forgottenEmail} /> : null}
      {showErrorModal ? <ResetPasswordErrorModal email={forgottenEmail} /> : null}
      <div className="wrapper">
        <div id="loginMain">
          <img
            className="signup-bg top"
            src={`${windowWidth > 926 ? randomImages[randomNumber] : randomMobileImages[randomMobileNumber]}`}
            style={isMobile ?
              {
                minHeight: '100%',
                width: '100%'
              }
              : null
            }
            alt="background"
          />
          <div className="middle-xy">
            <FormProvider {...methods}>
              <form
                id="loginForm"
                className="signup-form border-0"
                autoComplete="off"
                noValidate="novalidate"
              >
                <ErrorPopup whiteText={true} condition={Object.keys(errors).length > 0} message="Oops! Invalid email or password. Please try again." />
                <Input name="email" className="form-control" placeholder="Your email" />
                <PasswordInput leaveErrors={true} />
                <div className="form-group float-left forgot-pw-div">
                  <span className="forget-password subpixel" onClick={() => closeButtonRef.current.triggerModal()}>Forgot password</span>
                </div>

                {false ? <Link to={{ pathname: '/user/' + fakeFacename[randomInt].id, state: { from: 'login' } }} className="face-name-div form-group float-right text-right">
                  <div className="face-name">
                    <span className="forget-password subpixel">Hi, I'm {fakeFacename[randomInt].firstname}</span>
                  </div>
                  <div className="arrow"><MdKeyboardArrowRight /></div>
                </Link> : null}
                
                <div className="login-buttons">
                  <button className={`footer-buttons float-right login ${formData.length !== 0 ? "no-hover" : ""}`} onClick={handleSubmit(onSubmit)}>
                    <span className={isSubmitting ? 'd-none' : ''}>Log In</span>
                    <img className={isSubmitting ? '' : 'd-none'} src={preloader} alt="preloader" />
                  </button>
                  <Link to="/signup">
                    <button className="footer-buttons float-left pink-text join">Join us, it's free</button>
                  </Link>
                </div>
              </form>
            </FormProvider>
          </div>
        </div>
      </div>
      <Footer displayAll={true} className="login" />
    </div>
  );
}

const ForgotPasswordModal = forwardRef(({ 
  passForgottenEmail, 
  windowWidth,
  onSuccess,
  onError
}, ref) => {
  const { trigger, isLoading, isSuccess, isError } = useTriggerPasswordReset();

  const methods = useForm({
    shouldFocusError: false,
    resolver: yupResolver(schema2),
  });
  const { handleSubmit, watch, reset, setError, getValues, formState: { errors, isSubmitted, isSubmitting } } = methods;
  const [showModal, toggleModal] = useReducer(
    showModal => !showModal,
    false
  );

  const [opacity, setOpacity] = useState(1);
  const [formHasValue, setFormHasValue] = useState(false);
  const [formData, setFormData] = useState([]);

  useImperativeHandle(ref, () => ({
    triggerModal() {
      toggleModal()
    }
  }))

  watch(data => {
    if (!Object.values(data).some(val => val)) {
      setFormHasValue(false);
    }
    else setFormHasValue(true);
  })

  const getOpacity = (opacity) => setOpacity(opacity);
  const onReset = () => {
    reset({});
    clearEmptyFields();
    setFormHasValue(false);
  }
  const onSubmit = (data, e) => {
    trigger({
      email: data.email2
    })
  }

  const errorpopup = errors.email2 && errors.email2.type !== 'required' ?
    {
      condition: true,
      message: errors.email2.message
    }
    : {}

  useEffect(() => {
    if (isSubmitted || isSubmitting) addEmptyFields(errors);
    // eslint-disable-next-line
  }, [isSubmitted, isSubmitting]);

  useEffect(() => {
    if (isError) {
      setError('email2', {
        message: 'Oops! Email is invalid'
      });
    }
  }, [isError])

  useEffect(() => {
    if (isLoading) {
      // hacking what the previous dev did
      setFormData([true])
    } else {
      setFormData([])
    }
  }, [isLoading])

  useEffect(() => {
    if (isSuccess) {
      passForgottenEmail(getValues('email2'))
      toggleModal(false)
      onSuccess()
    } 
    if (isError) {
      toggleModal(false)
      onError()
    }
  }, [isSuccess, isError])

  return (
    <Modal
      id="loginModal"
      backdropClassName="login-modal-backdrop"
      dialogClassName="fa-modal-dialog"
      contentClassName="fa-modal-content"
      show={showModal}
      onHide={toggleModal}
    >
      <div className="trigger-close-area d-block" onClick={toggleModal}></div>
      <Modal.Header>
        {windowWidth <= 926 ?
          <div className="field-label position-absolute">
            <div className="reset-password-icon sprites sprites-image-3"></div>
            <span className="pink-text">forgot password</span>
          </div>
          : null}
          <CloseButton closeModal={toggleModal} passOpacity={getOpacity} darkGrey={true} />
      </Modal.Header>
      <Modal.Body className="fa-modal-body middle-xy" style={{ opacity: opacity }}>
        {windowWidth > 926 ?
          <div className="field-label pb-4">
            <div className="reset-password-icon sprites sprites-image-3"></div>
            <span className="pink-text">forgot password</span>
          </div>
          : null}
        <div className="">
          <FormProvider {...methods}>
            <form
              id="modalForm"
              className="signup-form border-0"
              autoComplete="off"
              noValidate="novalidate"
            >
              <ErrorPopup condition={errorpopup.condition} message={errorpopup.message} />
              <Input label="Your email" name="email2" className="form-control modal-popup" placeholder="" />
            </form>
          </FormProvider>
        </div>
      </Modal.Body>
      <FormButtons opacity={opacity} disabled={!formHasValue} reset={onReset} submit={handleSubmit(onSubmit)} formData={formData} preloader={preloader2} />
    </Modal>
  )
})

function ConfirmationModal({ email }) {
  const [showModal, toggleModal] = useReducer(
    showModal => !showModal,
    true
  );

  return (
    <Modal
      id="cfmModal"
      backdropClassName="login-modal-backdrop"
      dialogClassName="fa-modal-dialog"
      contentClassName="fa-modal-content"
      show={showModal}
      onHide={toggleModal}
    >
      <Modal.Header className="pb-0">
        <div className="mail-icon sprites sprites-image-3"></div>
      </Modal.Header>
      <Modal.Body className="fa-modal-body">
        <p className="pink-text">Ok, got it!</p>
        <p className="pn">We've just sent you an email at <b className="pn-bold">{email}</b><br /> on how to change your password.</p>
      </Modal.Body>
      <Modal.Footer className="footer-buttons-div">
        <button className="footer-buttons pink-text" onClick={toggleModal}>Ok!</button>
      </Modal.Footer>
    </Modal>
  )
}

function ResetPasswordErrorModal({ email }) {
  const [showModal, toggleModal] = useReducer(
    showModal => !showModal,
    true
  );

  return (
    <Modal
      id="cfmModal"
      backdropClassName="login-modal-backdrop"
      dialogClassName="fa-modal-dialog"
      contentClassName="fa-modal-content"
      show={showModal}
      onHide={toggleModal}
    >
      <Modal.Header className="pb-0">
        <div className="mail-icon sprites sprites-image-3"></div>
      </Modal.Header>
      <Modal.Body className="fa-modal-body">
        <p className="pink-text">Oops</p>
        <p className="pn">We could not send you an email at <b className="pn-bold">{email}</b><br /> on how to change your password. Please try again later.</p>
      </Modal.Body>
      <Modal.Footer className="footer-buttons-div">
        <button className="footer-buttons pink-text" onClick={toggleModal}>Ok!</button>
      </Modal.Footer>
    </Modal>
  )
}
